import { createSubmission as createSubmissionRequest } from '@wix/ambassador-forms-v4-submission/http';
import { SubmissionStatus } from '@wix/ambassador-forms-v4-submission/types';
export const submitForm = ({ httpClient, requestCaptcha, errorHandler })=>async (formId, values)=>{
        const submission = {
            formId,
            submissions: values,
            status: SubmissionStatus.PENDING
        };
        const captchaToken = await requestCaptcha();
        const response = await errorHandler.withErrorHandler(()=>httpClient.request(createSubmissionRequest({
                submission,
                captchaToken
            })), {
            errorCodesMap: {
                applicationError: {
                    INVALID_CAPTCHA: false,
                    SITE_IS_A_TEMPLATE: false,
                    FORM_NOT_FOUND: false,
                    FORM_RETRIEVAL_ERROR: false,
                    SUBMISSION_VALIDATION: false
                }
            }
        });
        return {
            ...response.data
        };
    };

//# sourceMappingURL=submit-form.js.map